import { useSocketEvent, useSocketState } from '../../helpers/useSocket'
import React, { useState, useEffect } from 'react'
import { Bar } from '../../components/Bar100'
import colors from '../../config/colors.json'

export function LiveGameSheepCounter({ leftColor, rightColor }) {
	const [sheepState, setSheepState] = useState({})

	useSocketEvent('updateSheep', (newData) => {
		setSheepState(newData)
	})

	return (
		<div className={`sheepWrapper w-[286px]`}>
			<div
				className={`sheepCounter top-64 w-[286px] wipe ${sheepState.showSheepPopup ? 'wipe2' : ''}`}
			>
				<div className="flex flex-col absolute justify-between w-full h-full p-3">
					<div className="h-[20px] relative flex flex-col">
						<img
							className="self-center -mt-5 w-[58px]"
							src="/sheepCounter/sheepIcon.png"
						/>
					</div>
					<div className="grid grid-cols-3 text-2xl braked mx-2">
						<h1 className="text-white">
							{parseInt(sheepState.leftCount)}
						</h1>
						<h1 className="text-white text-center">
							{sheepState.neutralCount !== 0 &&
								parseInt(sheepState.neutralCount)}
						</h1>
						<h1 className="text-white text-right">
							{parseInt(sheepState.rightCount)}
						</h1>
					</div>
					<Bar
						thickness="20px"
						values={[
							sheepState.leftCount,
							sheepState.neutralCount,
							sheepState.rightCount,
						]}
						colors={[
							colors[leftColor]?.mainColor,
							'rgb(255, 255, 255)',
							colors[rightColor]?.mainColor,
						]}
					/>
				</div>
				<img
					className="sheepCounterBackground"
					src="/sheepCounter/background.png"
				/>
			</div>
		</div>
	)
}
